import { Component, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AnnualDeclarationFormService } from '../../annual-declaration-form/shared/service/annual-declaration-form.service';
import { AnnualDeclarationState } from '../../annual-declaration-form/shared/state/annual-declaration.state';

@Component({
    selector: 'odq-save-button',
    templateUrl: './save-button.component.html',
    styleUrls: ['./save-button.component.scss'],
    standalone: false
})
export class SaveButtonComponent implements OnInit {

  @Select(AnnualDeclarationState.saving) saving$: Observable<boolean>;

  constructor(
    private annualDeclarationFormService: AnnualDeclarationFormService,
  ) { }

  ngOnInit() {
  }

  saveForm() {
    this.annualDeclarationFormService.saveForm();
  }

}
